import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from './components/nuxt-error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_8d8b171a from 'nuxt_plugin_plugin_8d8b171a' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_plugin_1c36e9ca from 'nuxt_plugin_plugin_1c36e9ca' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_nuxtvueselect_77a82ef2 from 'nuxt_plugin_nuxtvueselect_77a82ef2' // Source: ./nuxt-vue-select.js (mode: 'client')
import nuxt_plugin_image_149f1df8 from 'nuxt_plugin_image_149f1df8' // Source: ./image.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_47983c9e from 'nuxt_plugin_cookieuniversalnuxt_47983c9e' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_router_025cce74 from 'nuxt_plugin_router_025cce74' // Source: ./router.js (mode: 'all')
import nuxt_plugin_markdownit_7ddd6415 from 'nuxt_plugin_markdownit_7ddd6415' // Source: ./markdownit.js (mode: 'all')
import nuxt_plugin_axios_0aa97409 from 'nuxt_plugin_axios_0aa97409' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_nuxtclientinit_4f9c6369 from 'nuxt_plugin_nuxtclientinit_4f9c6369' // Source: ../plugins/nuxt-client-init.js (mode: 'client')
import nuxt_plugin_slider_09b33320 from 'nuxt_plugin_slider_09b33320' // Source: ../plugins/slider.js (mode: 'client')
import nuxt_plugin_gallery_763aebab from 'nuxt_plugin_gallery_763aebab' // Source: ../plugins/gallery.js (mode: 'client')
import nuxt_plugin_ismobile_795919f8 from 'nuxt_plugin_ismobile_795919f8' // Source: ../plugins/is-mobile.js (mode: 'client')
import nuxt_plugin_gmap_8c331c88 from 'nuxt_plugin_gmap_8c331c88' // Source: ../plugins/gmap.js (mode: 'client')
import nuxt_plugin_nl2br_75701d24 from 'nuxt_plugin_nl2br_75701d24' // Source: ../filters/nl2br.js (mode: 'all')
import nuxt_plugin_vuefinalmodal_4feb7bbe from 'nuxt_plugin_vuefinalmodal_4feb7bbe' // Source: ../plugins/vue-final-modal.js (mode: 'all')
import nuxt_plugin_apiservice_36f72900 from 'nuxt_plugin_apiservice_36f72900' // Source: ../services/api.service.js (mode: 'all')
import nuxt_plugin_storeservice_0f67dfd9 from 'nuxt_plugin_storeservice_0f67dfd9' // Source: ../services/store.service.js (mode: 'all')
import nuxt_plugin_seoservice_96b59d46 from 'nuxt_plugin_seoservice_96b59d46' // Source: ../services/seo.service.js (mode: 'all')
import nuxt_plugin_authservice_3eeb3744 from 'nuxt_plugin_authservice_3eeb3744' // Source: ../services/auth.service.js (mode: 'all')
import nuxt_plugin_meta_1a1a70ed from 'nuxt_plugin_meta_1a1a70ed' // Source: ./composition-api/meta.mjs (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"htmlAttrs":{"lang":"en"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":""},{"name":"format-detection","content":"telephone=no"},{"name":"og:type","content":"website"},{"name":"og:url","content":"https:\u002F\u002F3dfa.cz\u002Ffitness-skoleni\u002Fsummit-treneru-deti-a-mladeze-hry-jako-nastroj-treninku"},{"name":"og:title","content":"Summit Trenérů Dětí a Mládeže - Hry jako nástroj tréninku"},{"name":"og:description","content":""},{"name":"og:image","content":"https:\u002F\u002Fstrapi.3dfitnessgym.zkus.it\u002Fuploads\u002FA757_E209_EB_3_C_4_A2_A_8_BCD_9256506_C1439_1_105_c_3d65ec3132.jpeg"}],"link":[],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_8d8b171a === 'function') {
    await nuxt_plugin_plugin_8d8b171a(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_1c36e9ca === 'function') {
    await nuxt_plugin_plugin_1c36e9ca(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_nuxtvueselect_77a82ef2 === 'function') {
    await nuxt_plugin_nuxtvueselect_77a82ef2(app.context, inject)
  }

  if (typeof nuxt_plugin_image_149f1df8 === 'function') {
    await nuxt_plugin_image_149f1df8(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_47983c9e === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_47983c9e(app.context, inject)
  }

  if (typeof nuxt_plugin_router_025cce74 === 'function') {
    await nuxt_plugin_router_025cce74(app.context, inject)
  }

  if (typeof nuxt_plugin_markdownit_7ddd6415 === 'function') {
    await nuxt_plugin_markdownit_7ddd6415(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_0aa97409 === 'function') {
    await nuxt_plugin_axios_0aa97409(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_nuxtclientinit_4f9c6369 === 'function') {
    await nuxt_plugin_nuxtclientinit_4f9c6369(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_slider_09b33320 === 'function') {
    await nuxt_plugin_slider_09b33320(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gallery_763aebab === 'function') {
    await nuxt_plugin_gallery_763aebab(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_ismobile_795919f8 === 'function') {
    await nuxt_plugin_ismobile_795919f8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gmap_8c331c88 === 'function') {
    await nuxt_plugin_gmap_8c331c88(app.context, inject)
  }

  if (typeof nuxt_plugin_nl2br_75701d24 === 'function') {
    await nuxt_plugin_nl2br_75701d24(app.context, inject)
  }

  if (typeof nuxt_plugin_vuefinalmodal_4feb7bbe === 'function') {
    await nuxt_plugin_vuefinalmodal_4feb7bbe(app.context, inject)
  }

  if (typeof nuxt_plugin_apiservice_36f72900 === 'function') {
    await nuxt_plugin_apiservice_36f72900(app.context, inject)
  }

  if (typeof nuxt_plugin_storeservice_0f67dfd9 === 'function') {
    await nuxt_plugin_storeservice_0f67dfd9(app.context, inject)
  }

  if (typeof nuxt_plugin_seoservice_96b59d46 === 'function') {
    await nuxt_plugin_seoservice_96b59d46(app.context, inject)
  }

  if (typeof nuxt_plugin_authservice_3eeb3744 === 'function') {
    await nuxt_plugin_authservice_3eeb3744(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_1a1a70ed === 'function') {
    await nuxt_plugin_meta_1a1a70ed(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
